export default __webpack_public_path__ + "static/ProValue_3-0783178b5e5f568f1894f19fbc7ec19a.webp";